var _defs, _circle, _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    width: 143,
    height: 143,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 3,
    stdDeviation: 1.5,
    floodColor: "#000",
    floodOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "inset",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tri-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5 18 C73.2 18 74.8 18.9 75.7 20.4 L119.5 96.4 C121.4 99.6 119.1 103.6 115.3 103.6 L27.7 103.6 C23.9 103.6 21.6 99.6 23.5 96.4 L67.3 20.4 C68.2 18.9 69.8 18 71.5 18 Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 71.5,
    r: 68,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 18 C73.2 18 74.8 18.9 75.7 20.4 L119.5 96.4 C121.4 99.6 119.1 103.6 115.3 103.6 L27.7 103.6 C23.9 103.6 21.6 99.6 23.5 96.4 L67.3 20.4 C68.2 18.9 69.8 18 71.5 18 Z",
    fill: "#F4A328",
    filter: "url(#drop)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 103.6 L115.3 103.6 L107 89 L36 89 Z",
    fill: "#995a00",
    opacity: 0.35,
    clipPath: "url(#tri-clip)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 18 C73.2 18 74.8 18.9 75.7 20.4 L119.5 96.4 C121.4 99.6 119.1 103.6 115.3 103.6 L27.7 103.6 C23.9 103.6 21.6 99.6 23.5 96.4 L67.3 20.4 C68.2 18.9 69.8 18 71.5 18 Z",
    fill: "none",
    stroke: "#995a00",
    strokeWidth: 0,
    style: {
      filter: "drop-shadow(-5px -5px 0px rgba(0,0,0,0.15)) inset"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 38,
    width: 13,
    height: 34,
    rx: 5,
    fill: "#995a00",
    filter: "url(#drop)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 46,
    width: 4,
    height: 11,
    rx: 2,
    fill: "white",
    opacity: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 79,
    width: 13,
    height: 14,
    rx: 4,
    fill: "#995a00",
    filter: "url(#drop)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 90,
    width: 4.91,
    height: 11.789,
    rx: 2,
    fill: "white",
    opacity: 0.7,
    transform: "rotate(30 35.5 95.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimer-icon.00970434422a4ce4f9422fd53abb6d8f.svg";
export { ForwardRef as ReactComponent };